import axios from "axios";
import * as loaderActions from "@common/store/loader/loader.actionsType";
import systemRoutes from "@common/../static/scripts/system.routes";

const redirectToLogin = () => {
  window.location.href = `${systemRoutes.Common.Url}/#/login`;
};

const getHttp = (store, baseUrl, auth) => {
  const http = axios.create({
    baseURL: baseUrl,
    timeout: 12000000
  });

  let requestAdded = 0;
  let requestCompleted = 0;
  let addRequest = () => {
    requestAdded++;
    if (store)
      store.dispatch({
        type: loaderActions.LOADER_SHOW
      });
  };
  let subRequest = () => {
    requestCompleted++;
    if (store && requestAdded == requestCompleted)
      store.dispatch({
        type: loaderActions.LOADER_HIDE
      });
  };

  http.interceptors.request.use(
    function (config) {
      if (auth) {
        var localStorage = window.localStorage.getItem("SESSION_INFO_STORAGE_KEY_COMMON");
        const token = localStorage ? JSON.parse(localStorage).accessToken : undefined;
        if (token && !config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }

      //Loading
      if (config && config.noLoading) {
        requestAdded++;
        return config;
      }
      addRequest();
      return config;
    },
    function (err) {
      subRequest();
      return Promise.reject(err);
    }
  );

  http.interceptors.response.use(
    function (response) {
      // if (response && response.status == 401) {
      //   redirectToLogin();
      // }
      subRequest();
      return response;
    },
    function (error) {
      if (error && error.response) {
        switch (error.response.status) {
          // case 401:
          //   redirectToLogin();
          //   break;
          default:
            _showError(error.response.data);
            break;
        }
      } else _showError(error);

      subRequest();
      return Promise.reject(error);
    }
  );

  return http;
};

export default getHttp;
